import React from 'react';
import { cn } from '../../utils/cn';

// Layout pieces for long settings forms (app and tenant configuration).

const TONES = {
    title: 'text-fg',
    label: 'text-fg',
    hint: 'text-fg-muted',
    divider: 'border-line-subtle',
};

/** Titled block within a settings form; `id` is the scroll target for section navigation. */
export const SettingsSection = ({ id, title, hint, children }) => (
    <section id={id} className={cn('scroll-mt-4 border-t pt-8 first:border-t-0 first:pt-0', TONES.divider)}>
        <div className="mb-5">
            <h3 className={cn('text-base font-semibold tracking-tight', TONES.title)}>{title}</h3>
            {hint && <p className={cn('mt-1 max-w-2xl text-sm', TONES.hint)}>{hint}</p>}
        </div>
        {children}
    </section>
);

/** Responsive 1/2/3-column grid of settings rows. */
export const SettingsGrid = ({ children }) => (
    <div className="grid grid-cols-1 gap-x-10 gap-y-6 md:grid-cols-2 xl:grid-cols-3">{children}</div>
);

/** Label + hint on the left, compact control (Switch, NumberInput, Segmented) on the right. */
export const SettingRow = ({ label, hint, children, muted }) => (
    <div className={cn('flex items-start justify-between gap-4', muted && 'opacity-50')}>
        <div className="min-w-0">
            <div className={cn('text-sm font-medium', TONES.label)}>{label}</div>
            {hint && <p className={cn('mt-0.5 text-xs leading-relaxed', TONES.hint)}>{hint}</p>}
        </div>
        <div className="flex-shrink-0 pt-0.5">{children}</div>
    </div>
);

/** Label above a full-width control (free text). */
export const SettingField = ({ label, hint, children, className = '' }) => (
    <div className={className}>
        <label className={cn('block text-sm font-medium mb-1.5', TONES.label)}>{label}</label>
        {children}
        {hint && <p className={cn('mt-1.5 text-xs leading-relaxed', TONES.hint)}>{hint}</p>}
    </div>
);
